export default "__VITE_ASSET__BrPU7acG__"